import { render, staticRenderFns } from "./ContentFilesView.vue?vue&type=template&id=7bc8016f&scoped=true&"
import script from "./ContentFilesView.vue?vue&type=script&lang=js&"
export * from "./ContentFilesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8016f",
  null
  
)

export default component.exports